import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import { OverlayPanel } from "primereact/overlaypanel";
import "./customModal.css";

const layouts = [
  {
    id: 0,
    icon: (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
          <path d="M975 4785 c-162 -29 -313 -112 -432 -238 -118 -125 -189 -269 -213 -432 -8 -58 -10 -508 -8 -1610 l3 -1530 23 -73 c75 -244 248 -438 470 -528 157 -63 31 -59 1742 -59 l1555 0 83 22 c291 78 507 293 584 583 l23 85 0 1555 c0 1711 4 1585 -59 1742 -90 222 -284 395 -528 470 l-73 23 -1550 2 c-1231 1 -1564 -1 -1620 -12z m3145 -321 c155 -35 281 -149 342 -310 l23 -59 3 -1495 c2 -1066 -1 -1514 -8 -1562 -34 -204 -194 -364 -398 -398 -48 -7 -496 -10 -1562 -8 l-1495 3 -59 23 c-117 44 -197 111 -260 215 -69 116 -66 32 -66 1684 0 1620 -2 1550 56 1665 36 71 123 159 193 197 117 62 34 59 1669 60 1318 1 1501 -1 1562 -15z" />
          <path d="M3775 3986 c-17 -7 -183 -169 -370 -359 -186 -191 -341 -345 -343 -342 -2 2 -7 98 -11 213 -7 200 -9 212 -32 246 -26 40 -90 76 -132 76 -68 0 -146 -63 -156 -126 -5 -33 11 -649 22 -806 2 -39 11 -78 21 -92 35 -55 46 -57 495 -73 295 -10 426 -11 451 -4 20 6 51 27 70 46 33 34 35 40 35 103 0 77 -17 107 -76 141 -31 18 -61 21 -247 27 -117 4 -212 9 -212 11 0 3 154 162 343 354 197 200 348 362 356 381 7 19 11 51 8 77 -12 106 -124 170 -222 127z" />
          <path d="M1394 2376 c-95 -42 -126 -159 -65 -244 38 -54 69 -61 301 -69 l211 -6 -345 -346 c-190 -190 -350 -359 -355 -374 -49 -130 63 -256 192 -217 35 10 97 67 390 358 339 338 347 346 348 312 6 -281 15 -397 35 -430 30 -52 88 -82 147 -77 54 5 90 27 126 78 l23 34 -7 270 c-13 517 -19 620 -38 649 -10 15 -30 31 -44 37 -14 5 -212 16 -441 24 -492 17 -440 17 -478 1z" />
        </g>
      </svg>
    ),
    label: "Default",
  },
  {
    id: 1,
    icon: (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
          <path d="M998 4790 c-202 -35 -404 -158 -522 -318 -50 -68 -102 -177 -128 -268 l-23 -79 0 -1570 c0 -1494 1 -1573 18 -1635 72 -252 247 -454 475 -546 157 -63 30 -59 1752 -59 l1565 0 90 28 c274 86 466 278 552 552 l28 90 0 1565 c0 1496 -1 1568 -19 1635 -75 283 -285 500 -566 587 l-75 23 -1550 1 c-852 1 -1571 -2 -1597 -6z m3120 -325 c160 -38 282 -148 344 -311 l23 -59 3 -1502 c3 -1641 5 -1577 -55 -1700 -36 -75 -131 -170 -206 -206 -121 -59 -61 -57 -1662 -57 -1602 0 -1545 -2 -1665 57 -116 56 -221 196 -249 331 -8 37 -11 492 -11 1540 0 1291 2 1495 15 1551 41 174 180 313 353 355 88 22 3019 22 3110 1z" />
          <path d="M2985 3984 c-46 -24 -63 -43 -81 -90 -28 -74 3 -157 73 -192 32 -17 72 -21 252 -28 l213 -9 -346 -352 c-190 -193 -350 -363 -356 -378 -16 -41 -12 -107 9 -145 22 -41 89 -80 138 -80 19 0 48 7 66 17 18 9 186 172 373 362 l341 346 8 -211 c6 -189 10 -216 29 -250 30 -55 99 -89 161 -79 59 8 120 64 130 117 4 20 0 223 -8 450 -12 346 -17 419 -31 446 -32 61 -43 63 -450 78 -476 17 -485 17 -521 -2z" />
          <path d="M2170 2369 c-19 -11 -186 -171 -371 -356 l-336 -335 -6 129 c-4 70 -7 162 -7 203 -1 131 -51 199 -154 208 -59 4 -105 -20 -143 -77 -28 -41 -28 -75 -10 -571 11 -294 14 -329 33 -360 38 -67 45 -68 509 -85 413 -15 419 -15 459 5 109 53 122 200 24 273 -32 24 -134 35 -330 36 -76 1 -138 4 -138 8 0 4 155 163 344 353 375 376 377 378 355 464 -27 105 -141 157 -229 105z" />
        </g>
      </svg>
    ),
    label: "Full Screen",
  },
  {
    id: 2,
    icon: (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
          <path d="M1795 4691 l-960 -6 -60 -24 c-169 -67 -286 -197 -330 -367 -13 -51 -15 -273 -15 -1734 0 -1832 -3 -1722 58 -1848 37 -77 141 -181 220 -221 125 -63 19 -60 1847 -63 1575 -3 1674 -2 1735 15 36 10 90 30 120 45 75 36 180 142 219 220 65 129 61 10 61 1852 0 1832 3 1722 -58 1848 -36 75 -150 191 -222 225 -128 61 -106 60 -915 62 -407 1 -1172 -1 -1700 -4z m1068 -428 l337 -6 0 -1697 0 -1697 -337 -6 c-186 -4 -693 -7 -1126 -7 -876 0 -845 -2 -872 64 -22 53 -22 3239 0 3292 27 66 -6 63 870 64 435 0 942 -3 1128 -7z m1343 -8 c68 -28 64 89 64 -1695 0 -1391 -2 -1615 -15 -1646 -24 -59 -44 -62 -352 -56 l-273 5 0 1698 0 1699 223 3 c122 1 244 3 270 5 26 1 63 -5 83 -13z" />
          <path d="M1630 3184 c-58 -25 -109 -83 -126 -142 -30 -102 -11 -138 179 -329 l152 -153 -152 -152 c-190 -192 -209 -228 -179 -330 25 -86 115 -158 198 -158 87 0 101 11 351 259 131 130 250 256 265 280 36 61 36 141 -1 202 -40 69 -473 494 -527 518 -53 24 -112 26 -160 5z" />
        </g>
      </svg>
    ),
    label: "Sidebar",
  },
];

const CustomModal = forwardRef((props, ref) => {
  const [modalLayout, setLayout] = useState(0);
  const {
    renderItem,
    visible,
    title,
    showHeader,
    position,
    filters = () => {},
    onHandleClose,
    showCreateDate = false,
    showLeftSidebarIcon = false,
    showMoreIcon = false,
    showMoreOptions,
    secondaryTitle,
    createdDate,
    getModalLayout,
    showLayoutIcon = true,
  } = props;

  const navigate = useNavigate();
  const op = useRef(null);
  useImperativeHandle(ref, () => ({ getModalLayout: () => modalLayout }));

  const onClose = () => {
    onHandleClose !== undefined ? onHandleClose() : navigate(-1);
  };

  const onToggleMenu = () => {
    const popupSidebar = document.getElementById("popupSidebar");
    const popupContentGrid = document.getElementById("popupContentGrid");

    if (popupSidebar) {
      popupSidebar.classList.toggle("hide-popup-sidebar");
    }

    if (popupContentGrid) {
      popupContentGrid.classList.toggle("hide-content-padding");
    }
  };

  useEffect(() => {
    if (getModalLayout) {
      getModalLayout(modalLayout);
    }
  }, [modalLayout]);

  return (
    <div
      className={`custom-modal-container ${
        showHeader && position === "right" ? "custom-sidebar" : modalLayout === 1 ? "full-screen" : modalLayout === 2 ? "sidebar" : modalLayout === 3 ? "minimize" : ""
      }`}
    >
      <Dialog
        position={showHeader && position ? position : modalLayout === 2 ? "right" : "center"}
        appendTo="self"
        header={modalLayout === 3 && secondaryTitle ? secondaryTitle : title}
        showHeader={showHeader}
        visible={visible}
        resizable={false}
        draggable={false}
        blockScroll={modalLayout !== 3}
        modal={modalLayout === 0}
        onHide={onClose}
        className={`custom-modal`}
      >
        {!showHeader && (
          <div className="custom-modal-header">
            {modalLayout !== 3 && showLeftSidebarIcon && (
              <button type="button" className="popup-sidebar-icon" onClick={onToggleMenu}>
                {/* <i className="ri-sidebar-unfold-line"></i> */}
                <i className="ri-sidebar-fold-line"></i>
              </button>
            )}

            <h4>{modalLayout === 3 && secondaryTitle ? secondaryTitle : title}</h4>
            <div className="modal-icons">
              {modalLayout !== 3 && showCreateDate && <span>Created on {createdDate}</span>}
              {modalLayout !== 3 && showMoreIcon && <></>}
              {modalLayout !== 3 && filters()}
              {/* <button
                type="button"
                onClick={() => {
                  setLayout(modalLayout === 3 ? 0 : 3);
                }}
              >
                <i className="ri-subtract-line"></i>
              </button>

              {modalLayout !== 3 && showLayoutIcon && <button onClick={(e) => op.current.toggle(e)}>{layouts[modalLayout].icon}</button>}

              <OverlayPanel className="custom-modal-resize" ref={op}>
                <ul className="layout-list">
                  {layouts.map(({ id, icon, label }) => (
                    <li key={id}>
                      <button
                        className={modalLayout === id ? "active" : ""}
                        onClick={(e) => {
                          setLayout(id);
                          op.current.toggle(e);
                        }}
                        type="button"
                      >
                        {icon} {label}
                      </button>
                    </li>
                  ))}
                </ul>
              </OverlayPanel> */}
              <button className="custom-modal-close" onClick={onClose}>
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
                  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                    <path d="M1175 4111 c-130 -32 -198 -156 -156 -286 11 -33 124 -151 624 -652 l612 -613 -612 -612 c-500 -502 -613 -620 -624 -653 -56 -174 90 -329 261 -279 53 15 75 35 668 627 l612 612 613 -612 c501 -500 619 -613 652 -624 180 -58 334 96 276 276 -11 33 -124 151 -624 653 l-612 612 612 613 c500 501 613 619 624 652 56 174 -89 329 -261 279 -53 -15 -75 -35 -667 -627 l-613 -612 -613 612 c-591 591 -614 612 -666 627 -59 17 -62 17 -106 7z" />
                  </g>
                </svg>
              </button>
            </div>
          </div>
        )}
        {modalLayout !== 3 && <div className="custom-modal-body">{renderItem()}</div>}
      </Dialog>
    </div>
  );
});

export default CustomModal;
